module.exports = __webpack_public_path__ + "src/img/lightningGreen.358e2f5c.svg";